import { downloadFile, hasError } from "@/utils/utils";
import TransactionsService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import dayjs from "dayjs";
export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async createQrFile({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await TransactionsService.createQrFile(payload);
        dispatch("handleResponse", res);
        if (hasError(res.status)) throw res.status;
        const fileName = `طلب توسّط إلى ${
          payload.destination
        } , ${dayjs().format("YYYY-MM-DD,hh;mm")}.pdf`;
        downloadFile(res.data, fileName);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تحميل الملف",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },

    handleResponse({ commit, dispatch }, res) {
      if (hasError(res.status)) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
